/**
 * 共通
 *
 * @class CommonController
 * @typedef {CommonController}
 */
class CommonController{
    /**
     * Creates an instance of CommonController.
     *
     * @constructor
     */
    constructor() {}
    /**
     * 初期化
     */
    init(){
        this.param = {
            pageTitleKey : 'pageTitle'
        };
        this.elements = {
            selectors : {
                html              : '',
                body              : '',
                breadcrumbLast    : '#main .breadcrumb ol li:last-child em',
                submitAll         : 'form [type="submit"]'
            }
        };
        Utils.initDataElements(this);
        this.initBreadcrumb();
    }
    /**
     * reCAPTCHAの時パンクズ修正
     */
    initBreadcrumb(){
        if(!this.elements.breadcrumbLast){
            return;
        }
        let pageTitle = this.elements.breadcrumbLast.innerText;
        if(Utils.isChallenge){
            pageTitle = Utils.getLS(this.param.pageTitleKey); 
            if(pageTitle){
                this.elements.breadcrumbLast.innerText = pageTitle;
            }
        }else{
            if(window._customer && ['activate_account','login','reset_password'].includes(window._customer.templatename)){
                this.elements.submitAll.forEach((submit,i)=>{
                    submit.addEventListener('click',(e)=>{
                        Utils.setLS(this.param.pageTitleKey,pageTitle);
                    });
                });
            }
        }
    }
}
window.addEventListener('DOMContentLoaded',(e) => {
    const cc = new CommonController();
    cc.init();
});

/**
 * stamped.ioのウィジェットのラベル・プレースホルダー変更を司る
 */
class StampedController{
    /**
     * Creates an instance of PasswordController.
     *
     * @constructor
     */
    constructor() {}
    get reviewCommentLabel(){
        let maxlength = this.data.commentMaxlength;
        if(this.elements.reviewsCommentTextarea){
            maxlength -= this.elements.reviewsCommentTextarea.value.length;
        }
        return this.data.commentLabelFormat.replace(/\%d/,maxlength.toString());
    }
    /**
     * 初期化
     */
    init(){
        this.elements = {
            selectors : {
                html                              : '',
                body                              : '',
                header                            : 'header',
                productInfoReviewBadge            : '.product-info .stamped-product-reviews-badge',
                reviews                           : '#stamped-main-widget',
                reviewsContainer                  : '#stamped-main-widget .stamped-container',
                reviewsContent                    : '#stamped-main-widget .stamped-container .stamped-content',
                reviewsTabContainer               : '#stamped-main-widget .stamped-container .stamped-content .stamped-tab-container',
                reviewsHeaderCaption              : '#stamped-main-widget .stamped-header .stamped-summary .stamped-summary-caption .stamped-summary-text[data-count]',
                reviewsWriteReviewActions         : '#stamped-main-widget .stamped-header .stamped-summary-actions',
                reviewsWriteReview                : '#stamped-main-widget .stamped-header .stamped-summary-actions .stamped-summary-actions-newreview',
                reviewsForm                       : '#stamped-main-widget .new-review-form',
                reviewsNameLabel                  : '#stamped-main-widget .new-review-form .stamped-form-contact .stamped-form-contact-name .stamped-form-label',
                reviewsNameInput                  : '#stamped-main-widget .new-review-form .stamped-form-contact .stamped-form-contact-name .stamped-form-input.stamped-form-input-text',
                reviewsEMailLabel                 : '#stamped-main-widget .new-review-form .stamped-form-contact .stamped-form-contact-email .stamped-form-label',
                reviewsEMailInput                 : '#stamped-main-widget .new-review-form .stamped-form-contact .stamped-form-contact-email .stamped-form-input.stamped-form-input-email',
                reviewsRatingLabel                : '#stamped-main-widget .new-review-form .stamped-form-review .stamped-form-review-rating .stamped-form-label',
                reviewsTitleLabel                 : '#stamped-main-widget .new-review-form .stamped-form-review .stamped-form-review-title .stamped-form-label',
                reviewsTitleInput                 : '#stamped-main-widget .new-review-form .stamped-form-review .stamped-form-review-title .stamped-form-input.stamped-form-input-text',
                reviewsCommentLabel               : '#stamped-main-widget .new-review-form .stamped-form-review .stamped-form-review-body .stamped-form-label',
                reviewsCommentTextarea            : '#stamped-main-widget .new-review-form .stamped-form-review .stamped-form-review-body .stamped-form-input .stamped-form-input.stamped-form-input-textarea',
                reviewsSubmitInput                : '#stamped-button-submit',
                reviewsThankyou                   : '#stamped-main-widget .stamped-messages',
                reviewsThankyouP1                 : '#stamped-main-widget .stamped-messages .stamped-thank-you p:nth-of-type(1)',
                reviewsThankyouP2                 : '#stamped-main-widget .stamped-messages .stamped-thank-you p:nth-of-type(2)',
                reviewsThankyouLinks              : '#stamped-main-widget .stamped-messages .stamped-thank-you .stamped-share-links',
                reviewsStarRatingBadgeAll         : '.stamped-product-reviews-badge.stamped-main-badge:not(.rewrited)'
            }
        };
        this.data = {
            commentLabelFormat         : '内容(%d)',
            commentMaxlength           : 1500
        };
        this.Ease = {
            easeInOut: function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1; }
        };
        Utils.initDataElements(this);
        this.initStamped();
        this.initReview();
        this.initStarRatingBadgeStyle();
        this.initStarRatingBadge();
    }
    /**
     * https://stampedsupport.stamped.io/hc/en-us/articles/10152607118619-Javascript-Events-References
     */
    initStamped(){
        /* フォーム投稿後 */
        this.addEventListenerStamped(document, 'stamped:reviews:submitted', (e)=>{
            this.removeStyleForDisplayForm();
            this.scrollToWithHeader(this.elements.reviewsThankyou);
        });
    }
    /**
     * https://stampedsupport.stamped.io/hc/en-us/articles/10152607118619-Javascript-Events-References
     * @param {HTMLElement} el 
     * @param {String} eventName 
     * @param {Function} handler 
     */
    addEventListenerStamped(el, eventName, handler) { 
        if (el.addEventListener) {
            el.addEventListener(eventName, handler);
        }else{
            el.attachEvent('on' + eventName, function () { handler.call(el); });
        }
    }
    /**
     * stamped.ioのウィジェットのラベル・プレースホルダー変更
     */
    initReview(){
        /* レビューブロックが無い場合処理中止 */
        if(!this.elements.reviews){
            return;
        }
        /* reviewsWriteReviewが表示されるまで再起処理 */
        Utils.updateDataElements(this,'reviewsContainer');
        if(!this.elements.reviewsContainer){
            setTimeout(()=>{
                this.initReview();
            },200);
            return;
        }
        /* 価格横★マーク押下 */
        this.setTextBySelectorKey('productInfoReviewBadge',(elm)=>{
            elm.addEventListener('click',(e)=>{
                this.scrollToWithHeader(this.elements.reviews);
            });
        });
        /* stamped-tab-container */
        this.setTextBySelectorKey('reviewsTabContainer',(elm)=>{
            elm.remove();
        });
        /* X件のレビュー */
        this.setTextBySelectorKey('reviewsHeaderCaption',(elm)=>{
            if(elm.dataset.count){
                elm.innerText = elm.dataset.count + '件のレビュー'
            }
        });
        /* レビューを書くボタン */
        this.setTextBySelectorKey('reviewsWriteReview',(elm)=>{
            elm.innerText = 'レビューを書く';
            /* レビューを書くボタン押下後ボタン削除 */
            elm.addEventListener('click',(e)=>{
                this.setStyleForDisplayForm();
                this.scrollToWithHeader(this.elements.reviewsForm);
            });
        });
        this.setTextBySelectorKey('reviewsNameLabel','お名前（ニックネーム）');
        this.setTextBySelectorKey('reviewsNameInput','鎌倉胡桃子','placeholder');
        this.setTextBySelectorKey('reviewsEMailLabel','メールアドレス（ログインID）※公開時には非表示');
        this.setTextBySelectorKey('reviewsEMailInput','※レビューを投稿後には非公開となります','placeholder');
        this.setTextBySelectorKey('reviewsRatingLabel','評価');
        this.setTextBySelectorKey('reviewsTitleLabel','タイトル');
        this.setTextBySelectorKey('reviewsTitleInput','クルミッ子の美味しさについて','placeholder');
        this.setTextBySelectorKey('reviewsCommentLabel',this.reviewCommentLabel);
        this.setTextBySelectorKey('reviewsCommentTextarea','コメントを記入してください','placeholder');
        this.setTextBySelectorKey('reviewsSubmitInput','レビューを投稿する','value');
        /* 投稿後のテキスト修正 */
        this.setTextBySelectorKey('reviewsThankyouP1',(elm)=>{
            elm.innerText = 'レビューを投稿していただきありがとうございました。';
        });
        this.setTextBySelectorKey('reviewsThankyouP2',(elm)=>{
            elm.remove();
        });
        /* 投稿後のシェアリンク削除 */
        this.setTextBySelectorKey('reviewsThankyouLinks',(elm)=>{
            elm.remove();
        });
        this.setTextBySelectorKey('reviewsCommentTextarea',(elm)=>{
            elm.setAttribute('maxlength',this.data.commentMaxlength);
            /* コメント欄の文字数からラベルを書き換え */
            elm.addEventListener('input',(e)=>{
                this.elements.reviewsCommentLabel.innerText = this.reviewCommentLabel;
            });
        });
        /* 投稿後テキストの位置変更 */
        this.setTextBySelectorKey(['reviewsThankyou','reviewsContent'],(elm)=>{
            this.elements.reviewsContent.insertAdjacentElement('beforeend',this.elements[elm[0]]);
        });
        /* レビューフォームの位置変更 */
        this.setTextBySelectorKey(['reviewsForm','reviewsContent'],(elm)=>{
            this.elements.reviewsContent.insertAdjacentElement('beforeend',this.elements[elm[0]]);
        });
    }
    /**
     * レビューを書くボタン押下後
     */
    setStyleForDisplayForm(){
        let styleTag = document.createElement('style');
        styleTag.id = 'stampedformstyle';
        styleTag.innerText = `
${this.elements.selectors.reviewsWriteReview} {
    display:none;
}
#stamped-main-widget .stamped-container .new-review-form.stamped-visible {
    display:block !important;
}
`;
        document.getElementsByTagName('head')[0].insertAdjacentElement('beforeend',styleTag);
    }
    /**
     * フォーム強制表示スタイル削除
     */
    removeStyleForDisplayForm(){
        const style = document.getElementById('stampedformstyle');
        if(style){
            style.remove();
        }
    }
    /**
     * 指定要素のラベル・プレースホルダーを書き換える
     * @param {String || Array} selectorKey 
     * @param {String || Function} textOrFunc 
     * @param {String} paramName 
     * @param {Number} limit 
     * @param {Number} count 
     */
    setTextBySelectorKey(selectorKey,textOrFunc,paramName,limit,count){
        const isArray = Array.isArray(selectorKey);
        if(isArray || !this.elements[selectorKey]){
            Utils.updateDataElements(this,selectorKey);
        }
        /* 再起処理判定 */
        let recursion = false;
        if(isArray){
            selectorKey.forEach((key,i)=>{
                if(!this.elements[key]){
                    recursion = true;
                }
            });
        }else{
            recursion = !this.elements[selectorKey];
        }
        /* 対象要素が取得出来るまで再起処理 */
        if(recursion){
            /* 20回(10秒間)実行して要素を取得出来ない場合処理中止 */
            if(limit && count && limit <= count){
                return;
            }
            setTimeout(()=>{
                this.setTextBySelectorKey(selectorKey,textOrFunc,paramName,limit?limit:20,count?count+1:1);
            },500);
            return;
        }
        /* 書き換え */
        if(typeof textOrFunc === 'function'){
            textOrFunc(isArray ? selectorKey : this.elements[selectorKey]);
        }else{
            if(isArray){
                selectorKey.forEach((key,i)=>{
                    if(paramName){
                        this.elements[key][paramName] = textOrFunc;
                    }else{
                        this.elements[key].innerText = textOrFunc;
                    }
                });
            }else{
                if(paramName){
                    this.elements[selectorKey][paramName] = textOrFunc;
                }else{
                    this.elements[selectorKey].innerText = textOrFunc;
                }
            }
        }
    }
    /**
     * ★マークのラベルが一瞬表示されるのを防ぐ
     */
    initStarRatingBadgeStyle(){
        let styleTag = document.createElement('style');
        styleTag.id = 'starratingbadgestyle';
        styleTag.innerText = `
.stamped-product-reviews-badge.stamped-main-badge:not(.rewrited) .stamped-badge .stamped-badge-caption {
    display:none !important;
}
`;
        document.getElementsByTagName('head')[0].insertAdjacentElement('beforeend',styleTag);
    }
    /**
     * ★マークのラベル変更
     * @param {Number} limit 
     * @param {Number} count 
     */
    initStarRatingBadge(limit,count){
        /* 20回(20秒間)実行して要素を取得出来ない場合処理中止 */
        if(limit && count && limit <= count){
            return;
        }
        Utils.updateDataElements(this,'reviewsStarRatingBadgeAll');
        /* 要素が無い場合再起処理 */
        if(!this.elements.reviewsStarRatingBadgeAll.length){
            setTimeout(()=>{
                this.initStarRatingBadge(limit?limit:20,count?count+1:1);
            },1000);
            return;
        }
        /* ラベル書き換え */
        this.elements.reviewsStarRatingBadgeAll.forEach((elm,i)=>{
            const badge = elm.querySelector('.stamped-badge');
            const caption = elm.querySelector('.stamped-badge .stamped-badge-caption');
            if(badge && caption){
                caption.innerHTML = '<span class="rewrited">('+badge.dataset.rating+')</span>';
                elm.classList.add('rewrited');
            }
        });
        /* 書き換えが済んでいない要素がある場合1000ミリ秒後に再起処理 */
        Utils.updateDataElements(this,'reviewsStarRatingBadgeAll');
        if(this.elements.reviewsStarRatingBadgeAll.length){
            setTimeout(()=>{
                this.initStarRatingBadge(limit?limit:20,count?count+1:1);
            },1000);
        }else{
            const styleTag = document.getElementById('starratingbadgestyle');
            styleTag.remove();
        }
    }
    /**
     * スクロールアニメーションHeader考慮
     * @param {HTMLElement} elm 
     */
    scrollToWithHeader(elm){
        const height = this.elements.header.getBoundingClientRect().height;
        this.scrollToByElement(elm,800,height);
    }
    /**
     * スクロールアニメーション
     *
     * @param {HTMLElement} element
     * @param {Number} duration
     * @param {Number} headerHeight
     */
    scrollToByElement(element,duration,headerHeight){
        if(!element){
            return;
        }
        if(duration == undefined || duration == null){
            duration = 0;
        }
        if(!headerHeight){
            headerHeight = 0;
        }
        const targetPosition = element.getBoundingClientRect().top + window.scrollY - headerHeight;
        this.scrollTo(targetPosition,duration);
    }
    /**
     * スクロールアニメーション
     *
     * @param {Number} targetPosition
     * @param {Number} duration
     * @param {HTMLElement} scrollTarget
     */
    scrollTo (targetPosition,duration,scrollTarget) {
        if(!scrollTarget){
            scrollTarget = window;
        }
        const startPosition = scrollTarget == window ? ( document.documentElement.scrollTop || document.body.scrollTop ) : scrollTarget.scrollTop;
        requestAnimationFrame((nowTime)=>{
            this._loopForScrollTo(nowTime,nowTime,startPosition,targetPosition,duration,scrollTarget);
        });
    }
    /**
     * スクロールアニメーション再起処理
     *
     * @param {Number} nowTime
     * @param {Number} startTime
     * @param {Number} startPosition
     * @param {Number} targetPosition
     * @param {Number} duration
     * @param {HTMLElement} scrollTarget
     */
    _loopForScrollTo(nowTime,startTime,startPosition,targetPosition,duration,scrollTarget) {
        const time = nowTime - startTime;
        const normalizedTime = time / duration;
        if (normalizedTime < 1) {
            scrollTarget.scrollTo(0, startPosition + ((targetPosition - startPosition) * this.Ease.easeInOut(normalizedTime)));
            requestAnimationFrame((nowTime)=>{
                this._loopForScrollTo(nowTime,startTime,startPosition,targetPosition,duration,scrollTarget);
            });
        } else {
            scrollTarget.scrollTo(0, targetPosition);
        }
    }
}
window.addEventListener('DOMContentLoaded',(e) => {
    const sc = new StampedController();
    sc.init();
});